import { useTheme } from "@hooks";

export const PATH_SHADOW_GRADIENT_ID = "path_shadow_gradient";

export const PathShadow = () => {
  const { theme } = useTheme();

  const strokeColor = theme.chart.performance.stroke;

  return (
    <defs>
      <linearGradient
        id={PATH_SHADOW_GRADIENT_ID}
        x1="0"
        y1="0"
        x2="0"
        y2="50%"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor={strokeColor} stopOpacity={0.25} />
        <stop offset={0.2} stopColor={strokeColor} stopOpacity={0.2} />
        <stop offset={0.4} stopColor={strokeColor} stopOpacity={0.15} />
        <stop offset={0.5} stopColor={strokeColor} stopOpacity={0.1} />
        <stop offset={0.6} stopColor={strokeColor} stopOpacity={0.05} />
        <stop offset={0.8} stopColor={strokeColor} stopOpacity={0} />
      </linearGradient>
    </defs>
  );
};
